import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import About from "./components/About";
import Services from "./components/Services";
import Ecosystem from "./components/Ecosystem";
import WhyChoose from "./components/WhyChoose";
import Highlights from "./components/Highlights";
import Vision from "./components/Vision";
import Industries from "./components/Industries";
import Brands from "./components/Brands";
import Journey from "./components/Journey";
import Careers from "./components/Careers";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CursorGlow from "./components/CursorGlow";

function App() {
  return (
    <div className="App bg-black text-white min-h-screen overflow-x-hidden relative">
      <CursorGlow />
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <About />
        <Ecosystem />
        <Services />
        <WhyChoose />
        <Highlights />
        <Vision />
        <Industries />
        <Brands />
        <Journey />
        <Careers />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
